// ======================================================================
// File: useIndentList.js
// Module: PPE → Procurement → Indent
//
// Purpose:
// - Load indent list
// - Frontend-side filtering & pagination
// - Backend currently supports simple GET only
//
// ======================================================================

import { useEffect, useState } from "react";
import axiosClient from "../../../../../../api/axiosClient";

export default function useIndentList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allRows, setAllRows] = useState([]);

  // ✅ FIX: missing state
  const [total, setTotal] = useState(0);

  const [page, setPage] = useState(1);
  const pageSize = 10;

  const [filters, setFilters] = useState({
    search: "",
    status: "",
    indent_type: "",
    indent_source: "",
    from_date: "",
    to_date: "",
  });

  // --------------------------------------------------
  // LOAD INDENTS
  // --------------------------------------------------
  const load = async () => {
    setLoading(true);

    try {
      const res = await axiosClient.get(
        //"/api/ppe/material-flow/indent"
        "/api/ppe/material-flow/indent/list"
      );

      let rows = res.data?.data || [];

      // --------------------------------------------------
      // FRONTEND FILTERING
      // --------------------------------------------------
      if (filters.search) {
        const q = filters.search.toLowerCase();
        rows = rows.filter(
          (r) =>
            String(r.indent_no)
              .toLowerCase()
              .includes(q) ||
            String(r.remarks || "")
              .toLowerCase()
              .includes(q)
        );
      }

      if (filters.status) {
        rows = rows.filter(
          (r) => r.status === filters.status
        );
      }

      if (filters.indent_type) {
        rows = rows.filter(
          (r) =>
            r.indent_type === filters.indent_type
        );
      }

      if (filters.indent_source) {
        rows = rows.filter(
          (r) =>
            r.indent_source ===
            filters.indent_source
        );
      }
      // --------------------------------------------------
      // DATE FILTER
      // --------------------------------------------------

      if (filters.from_date) {
        rows = rows.filter(
          (r) =>
            r.indent_date >= filters.from_date
        );
      }

      if (filters.to_date) {
        rows = rows.filter(
          (r) =>
            r.indent_date <= filters.to_date
        );
      }
      const totalRows = rows.length;
      setAllRows(rows);
      setTotal(totalRows);

      // --------------------------------------------------
      // FRONTEND PAGINATION
      // --------------------------------------------------
      const start = (page - 1) * pageSize;
      const paged = rows.slice(
        start,
        start + pageSize
      );

      setItems(paged);
    } catch (err) {
      console.error("Failed to load indents", err);
      setItems([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  // --------------------------------------------------
  // EFFECTS
  // --------------------------------------------------
  useEffect(() => {
    load();
  }, [page]);

  return {
    items,
    allRows,
    total,
    loading,
    page,
    pageSize,
    setPage,
    filters,
    setFilters,
    reload: load,
  };
}
